<template>
  <v-row class="editTextQuestionComponent">
    <v-col
      cols="12"
      md="9"
    >
      <v-text-field
        v-model="questionCopy.question"
        :counter="500"
        :maxlength="500"
        :rules="[
          ...Rules.requiredNamed('Question'),
          ...Rules.max(questionCopy.question, 500)
        ]"
        label="Question text"
        required
      />
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-autocomplete
        v-model="questionCopy.question_type"
        :items="types"
        item-text="name"
        :rules="Rules.requiredNamed('Question type')"
        label="Question Type"
        return-object
        required
      />
    </v-col>
    <v-col
      v-if="!questionCopy.question_type.needs_options"
      cols="12"
      sm="6"
    >
      <v-text-field
        v-model="questionCopy.placeholder"
        :counter="50"
        :maxlength="50"
        :rules="[Rules.max(questionCopy.placeholder, 50)]"
        label="Placeholder"
        required
      />
    </v-col>
    <v-col
      v-else
      cols="12"
      sm="6"
    >
      <QuestionOptionsComponent
        :options="questionCopy.question_options"
        @newOption="updateOptions($event)"
      />
    </v-col>
    <v-col
      v-if="
        questionCopy.question_type.type !== 'signature' &&
          questionCopy.question_type.type !== 'signature-combined'
      "
      cols="12"
      sm="6"
    >
      <v-combobox
        v-model="questionCopy.selectedRules"
        :items="items"
        label="Validation Rules"
        multiple
        chips
        attach
      />
    </v-col>
    <v-col
      cols="12"
      md="9"
    >
      <v-switch
        v-model="includeDocuments"
        label="Include Document(s)"
      />
      <QuestionDocumentsEditComponent
        v-if="includeDocuments"
        :documents="questionCopy.question_documents"
        @newDocument="updateDocuments($event)"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'EditTextQuestionComponent',
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    types: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    questionCopy: {},
    items: ['required', 'email', 'phone', 'numeric', 'date'],
    includeDocuments: false
  }),
  computed: {
    //
  },
  watch: {
    question (newQuestion, oldQuestion) {
      this.questionCopy = newQuestion
    }
  },
  created () {
    this.questionCopy = this.question
    this.questionCopy.selectedRules = this.question.rules
      ? this.question.rules
      : []
    this.includeDocuments =
            this.questionCopy.question_documents != null &&
            this.questionCopy.question_documents.length > 0
  },
  methods: {
    updateDocuments (documents) {
      this.questionCopy.question_documents = documents
    }
  }
}
</script>
<style lang="scss">
.editTextQuestionComponent {
    //
}
</style>
